<template>
  <div class="renungan-landing">
    <div v-if="!renungan" id="loading">
      <VueLoading
        type="spin"
        color="#fdfdfd"
        :size="{ width: '80px', height: '80px' }"
      ></VueLoading>
    </div>
    <div v-else class="renungan-container">
      <div class="column" id="txt-section">
        <span class="sub-title">{{ renungan.title.rendered }}</span>
        <h3 class="body" id="tanggal">{{ convertDate(renungan.date) }}</h3>
        <h3 class="body">Baca: {{ extractTag(renungan.passage) }}</h3>
        <div v-html="renungan.excerpt.rendered" id="excerpt"></div>
      </div>
      <div class="container max-width" id="btn-section">
        <router-link to="/renungan" class="container" id="btn-baca">
          Baca Renungan
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { convertDate } from "../utils";
import { VueLoading } from "vue-loading-template";

export default {
  name: "RenunganLanding",
  components: {
    VueLoading
  },
  computed: mapState({
    renungan: state => state.renungan.renungan,
    loading: state => state.renungan.loading
  }),
  created() {
    this.$store.dispatch("renungan/getRenungan");
  },
  methods: {
    convertDate,
    extractTag: x => x.replace(/<[^>]+>/g, "")
  }
};
</script>
<style scoped>
.renungan-landing {
  color: #fdfdfd;
  width: 100%;
}

.renungan-container {
  text-align: left;
  padding: 1.5em;
  display: flex;
  flex-direction: column;
}

#btn-section {
  justify-content: flex-end;
}

#txt-section {
  padding: 2vh 0;
}

#btn-baca {
  width: 165px;
  height: 44px;
  text-align: center;
  border-radius: 10px;
  background-color: #d6e4ed;
  color: black;
  font-size: 1em;
  margin-top: 4vh;
}

#btn-baca:hover {
  background-color: rgb(214, 228, 237, 0.9);
}

.body {
  margin: 1vh 0;
}

@media screen and (max-width: 768px) {
  #excerpt,
  #tanggal {
    display: none;
  }

  .renungan-container {
    flex-direction: row;
  }

  #txt-section {
    padding: 0;
    width: 65%;
  }

  #btn-section {
    width: 35%;
  }

  #btn-baca {
    width: 25vw;
    height: 9vh;
    margin: 0;
  }
}

@media screen and (max-width: 320px) {
  #btn-baca {
    font-size: 0.8em;
  }
}
</style>
